import React, { useState } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { Container, PaddingWrapper, FlexRow } from 'components/styled-components';
import {
  Title,
  TitleWrapper,
  Wrapper,
} from 'containers/Manage-Questionnaire/styled-components';
import Pagination from 'components/pagination';
import colors from 'utils/colors';
import { IconNames } from '@blueprintjs/icons';
import {
  createDisplayCategory,
  updateDisplayCategory,
  archiveDisplayCategory,
  createQuestionType,
  updateQuestionType,
  archiveQuestionType,
  reorderQuestionTypes,
  reorderDisplayCategories
} from 'api/utils';
import AddRow from 'containers/Manage-Questionnaire/manage-metadata/AddRow';
import EditRow from 'containers/Manage-Questionnaire/manage-metadata/EditRow';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';
import CategoryEditor from 'containers/Manage-Questionnaire/manage-metadata/CategoryEditor';
import TypeEditor from 'containers/Manage-Questionnaire/manage-metadata/TypeEditor';

import { AppToaster } from 'components/AppToaster';
import QuestionTypeReorderDrawer from 'containers/Manage-Questionnaire/manage-metadata/QuestionTypeReorderDrawer';
import DisplayCategoryReorderDrawer from 'containers/Manage-Questionnaire/manage-metadata/DisplayCategoryReorderDrawer';

const PER_PAGE = 10;

const Metadata = ({
  categories,
  questionTypes,
  fetchAllQuestionTypes,
  fetchAllCategories,
  appUser,
  departments
}) => {
  // Display Categories pagination
  const [currentPageDC, setCurrentPageDC] = useState(0);
  const [perPageDC, setPerPageDC] = useState(PER_PAGE);
  const handlePageClickDC = currentPage => {
    setCurrentPageDC(currentPage);
  };
  const handlePerPageChangeDC = perPage => {
    setCurrentPageDC(0);
    setPerPageDC(perPage.value);
  };

  // Question Types pagination
  const [currentPageQT, setCurrentPageQT] = useState(0);
  const [perPageQT, setPerPageQT] = useState(PER_PAGE);
  const handlePageClickQT = currentPage => {
    setCurrentPageQT(currentPage);
  };
  const handlePerPageChangeQT = perPage => {
    setCurrentPageQT(0);
    setPerPageQT(perPage.value);
  };

  /* Jay trying to figure out these 'hook' things properly' */
  const [questionTypeDrawer, setQuestionTypeDrawer] = useState(false);
  const [displayCategoryDrawer, setDisplayCategoryDrawer] = useState(false);

  const handleSaveQuestionType = (updatedList) => {
	reorderQuestionTypes(updatedList)
		.then(res => {
			//close drawer
			setQuestionTypeDrawer(false);
			//toast the message
			AppToaster.show({
				message: res.data.message,
				intent: Intent.SUCCESS,
			});
			//repopulate question types
			setTimeout(fetchAllQuestionTypes, 300); //some how the network is too fast making this go off before the db finishes from the previous thing...
		})
		.catch(error => {
			AppToaster.show({
				message: error.response.data.message,
				intent: Intent.DANGER,
			});
		});
  };
  const handleSaveDisplayCategory = (updatedList) => {
	reorderDisplayCategories(updatedList)
		.then(res => {
			//close drawer
			setDisplayCategoryDrawer(false);
			//toast the message
			AppToaster.show({
				message: res.data.message,
				intent: Intent.SUCCESS,
			});
			//repopulate categories
			setTimeout(fetchAllCategories, 300); //some how the network is too fast making this go off before the db finishes from the previous thing...
		})
		.catch(error => {
			AppToaster.show({
				message: error.response.data.message,
				intent: Intent.DANGER,
			});
		});
  };

  return (
    <div>
		<FlexRow style={{flexDirection: "row-reverse"}}>
			<div>
				<Button
					minimal
					onClick={() => setQuestionTypeDrawer(true)}
					style={{
						color: colors.primary,
						fontSize: '0.9rem',
						marginRight: '3rem',
					}}
					text="Re-Order Question Types"
				/>
				<QuestionTypeReorderDrawer
					closeDrawer={() => setQuestionTypeDrawer(false)}
					openDrawer={() => setQuestionTypeDrawer(true)}
					isOpen={questionTypeDrawer}
					list={questionTypes}
					handleSaveOrder={handleSaveQuestionType}
				/>
				<Button
					minimal
					onClick={() => setDisplayCategoryDrawer(true)}
					style={{
						color: colors.primary,
						fontSize: '0.9rem',
						marginRight: '3rem',
					}}
					text="Re-Order Display Categories"
				/>
				<DisplayCategoryReorderDrawer
					closeDrawer={() => setDisplayCategoryDrawer(false)}
					openDrawer={() => setDisplayCategoryDrawer(true)}
					isOpen={displayCategoryDrawer}
					list={categories}
					handleSaveOrder={handleSaveDisplayCategory}
				/>
			</div>
		  </FlexRow>
      <PaddingWrapper />
      <Container background={colors.whiteGray}>
        <Wrapper>
          <TitleWrapper>
            <Title>Display Categories</Title>
          </TitleWrapper>

          {hasPermission(
            appUser.permissions,
            Permissions.CREATE_DISPLAY_CATEGORIES
          ) && (
            <AddRow
              create={createDisplayCategory}
              fetch={fetchAllCategories}
              buttonContent="Display Category"
              icon={IconNames.ADD}
            >
              <CategoryEditor />
            </AddRow>
          )}

          {categories.map(({ categoryName, categoryID }, i) => {
            return i < perPageDC * currentPageDC ||
              i >= perPageDC * (currentPageDC + 1) ? null : (
              <EditRow
                key={`${categoryName}-${categoryID}`}
                name={categoryName}
                id={categoryID}
                archive={archiveDisplayCategory}
                fetch={fetchAllCategories}
                update={updateDisplayCategory}
                canEdit={hasPermission(
                  appUser.permissions,
                  Permissions.MODIFY_DISPLAY_CATEGORIES
                )}
              >
                <CategoryEditor />
              </EditRow>
            );
          })}
          {categories && categories.length > PER_PAGE && (
            <Pagination
              numRecords={categories.length}
              perPage={perPageDC}
              currentPage={currentPageDC}
              onPageClick={handlePageClickDC}
              handlePerPageChange={handlePerPageChangeDC}
            />
          )}
        </Wrapper>
      </Container>

      <Container background={colors.whiteGray}>
        <Wrapper>
          <TitleWrapper>
            <Title>Question Types</Title>
          </TitleWrapper>
        </Wrapper>
        {hasPermission(
          appUser.permissions,
          Permissions.CREATE_QUESTION_TYPES
        ) && (
          <AddRow
            create={createQuestionType}
            fetch={fetchAllQuestionTypes}
            buttonContent="Question Type"
            icon={IconNames.ADD}
          >
            <TypeEditor mandatory={false} departments={departments} origDepartments={[]} />
          </AddRow>
        )}
        {questionTypes.map(({ typeName, typeID, mandatory, QuestionTypeDepartmentIDs }, i) => {
          return i < perPageQT * currentPageQT ||
            i >= perPageQT * (currentPageQT + 1) ? null : (
            <EditRow
              key={`${typeName}-${typeID}`}
              name={typeName}
              id={typeID}
              archive={archiveQuestionType}
              fetch={fetchAllQuestionTypes}
              update={updateQuestionType}
              canEdit={hasPermission(
                appUser.permissions,
                Permissions.MODIFY_QUESTION_TYPES
              )}
            >
              <TypeEditor mandatory={mandatory} departments={departments} origDepartments={QuestionTypeDepartmentIDs} />
            </EditRow>
          );
        })}
        {questionTypes && questionTypes.length > PER_PAGE && (
          <Pagination
            numRecords={questionTypes.length}
            perPage={perPageQT}
            currentPage={currentPageQT}
            onPageClick={handlePageClickQT}
            handlePerPageChange={handlePerPageChangeQT}
          />
        )}
      </Container>
    </div>
  );
};

export default Metadata;
